
import { MENU } from "../constants";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { SERVICES } from "../components/services";
import { FaFacebookF, FaXTwitter, FaInstagram } from "react-icons/fa6";
import { Link } from "react-router-dom";

const SOCIALS = [
    { icon: <FaFacebookF className="fill-white text-lg" />, link: "" },
    { icon: <FaXTwitter className="fill-white text-lg" />, link: "" },
    { icon: <FaInstagram className="fill-white text-lg" />, link: "" },
];

export default function Footer() {
    return (
        <footer className="main-bg">
            <div className="container">
                <div className="px-6 md:px-1 grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 pt-16 pb-10 gap-x-6 gap-y-10">
                    <div>
                        <h2>About Us</h2>
                        <div className="line"></div>
                        <p>
                            Touchlife Medical Care Foundation is a nonprofit health center
                            located in Ober, Oyam district Northern Uganda.
                        </p>
                        <div className="mt-8 flex gap-4 items-center">
                            {SOCIALS.map((s, i) => (
                                <div key={i} className="border border-white rounded-full p-2">
                                    {s.icon}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div>
                        <h2>Quick Links</h2>
                        <div className="line"></div>
                        <div className="flex flex-col gap-1">
                            {MENU.map((menu, i) => (
                                <Link
                                    to={`/${menu.link}`}
                                    key={i}
                                    className="flex gap-2 items-center"
                                >
                                    <MdOutlineKeyboardArrowRight className="text-xl fill-white" />
                                    <p>{menu.label}</p>
                                </Link>
                            ))}
                        </div>
                    </div>
                    <div>
                        <h2>Services</h2>
                        <div className="line"></div>
                        <div className="flex flex-col gap-1">
                            {SERVICES.map((service, i) => (
                                <div key={i} className="flex gap-2 items-center">
                                    <MdOutlineKeyboardArrowRight className="text-xl fill-white" />
                                    <p>{service.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div>
                        <h2>Contacts</h2>
                        <div className="line"></div>
                        <div className="flex flex-col gap-2">
                            <p>Plot 213 Acheng Kathy Odongo Street</p>
                            <p>Ober Village, Zuma parish, Myene Sub-County, Oyam District</p>
                            <p>P.O Box 360473 Gulu Uganda</p>
                            <p>Tel: +256 76 2741 856 | +256 726 618 861</p>
                            <p>Mobile: +256 752 744 171 | +256 752 238 402</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-bg-dark text-center">
                <p className="text-sm md:text-base p-6">
                    Copyright © 2025 TouchLife Medical Care Foundation. All Rights
                    Reserved.
                </p>
            </div>
        </footer>
    );
}
